import React from "react"
import { Frame, Table } from "components/common/orders"

export default () => {
  return (
    <Frame paymentStatuses={["payment_failed", "payment_expired"]}>
      <Table />
    </Frame>
  )
}
